import { GetStaticProps, GetStaticPaths } from 'next';

import DynamicSection from './DynamicSection';

import { getSectionsPageStaticProps } from 'services/staticGeneration/sectionsPage';
import { getSectionsPageStaticPaths } from 'services/incrementalStaticGeneration/sectionsPage';

export const getStaticProps: GetStaticProps = getSectionsPageStaticProps;
export const getStaticPaths: GetStaticPaths = getSectionsPageStaticPaths;

export default DynamicSection;
